<template>
  <div class="c-menu-list" :class="{frist: frist}">
    <div class="menu-item" v-for="(item, index) in list" :key="index">
      <div class="menu-title" @click="toMenu($event, item)">
        <div class="title-text">{{ item.title }}</div>
        <div class="title-more" v-if="item.min && item.min.length > 0" :class="{active: item.active}">
          <div class="more-btn"></div>
        </div>
      </div>
      <div class="menu-wrap" v-if="item.min && item.min.length > 0">
        <RecursiveMenu :list="item.min"></RecursiveMenu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RecursiveMenu",
  props: {
    list: {
      type: Array,
      default: []
    },
    frist: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {};
  },
  methods: {
    toMenu(ev, item) {
      item.active = !item.active;
      const list = ev.target.nextElementSibling;
      const more = ev.target.querySelector(".title-more");
      if (list) {
        if (item.active) {
          // list.style.height = list.scrollHeight + 20 + "px";
          list.style.height = "auto";
          more.className = "title-more active";
        } else {
          list.style.height = "0px";
          more.className = "title-more";
        }
        // setTimeout(() => {
        //   let parent = list.parentNode;
        //   while (parent && parent.nodeName !== "BODY") {
        //     if (parent.className.indexOf("menu-wrap") !== -1) {
        //       console.log(parent.scrollHeight);
        //       parent.style.height = parent.scrollHeight + "px";
        //     }
        //     parent = parent.parentNode;
        //   }
        // }, 400);
      }
      if (item.min && item.min.length > 0) {
        // return false;
      } else {
        if (!item.link) {
          this.util.showWait(true);
        } else {
          if (item.auth && !this.util.getAccessToken()) {
            this.util.showAuth({
              show: true,
              from: item.link
            });
          } else {
            this.util.toLink(item.link);
          }
        }
      }
      this.$emit("change", item);
    }
  }
};
</script>
<style lang="scss">
.c-menu-list {
  width: 100%; height: auto; padding: 0; margin: 0;
  .menu-item {
    box-sizing: border-box;
    width: 100%; height: auto;
  }
  .menu-title {
    box-sizing: border-box; display: flex; align-items: center; justify-content: center;
    width: 100%; height: 0.88rem; padding: 0 0.25rem 0 0.5rem;
    border-bottom: 1px solid #eeeeee;
    font-size: 0.24rem; line-height: 0.88rem;
  }
  .title-text {
    flex: 1; width: 60%;
    pointer-events: none;
  }
  .title-more {
    display: flex; align-items: center; justify-content: flex-end;
    width: 0.8rem; height: 0.8rem;
    pointer-events: none;
    &.active {
      .more-btn {
        transform: rotate(135deg) translateY(-2px);
      }
    }
  }
  .more-btn {
    box-sizing: border-box;
    width: 0.2rem; height: 0.2rem;
    border-left: 2px solid #cccccc; border-bottom: 2px solid #cccccc;
    transform: rotate(-45deg) translateY(-2px);
    transition: 0.3s;
  }
  .menu-wrap {
    box-sizing: border-box; overflow: hidden;
    width: 100%; height: 0; padding: 0 0.25rem 0 0.5rem;
    background: {
      color: #f4f4f4;
    };
    //transition: 0.3s;
  }
}
</style>